/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelEnumInterfaces.mustache
// synched 02.02.2023
import * as yup from 'yup';
import * as fastJSON from 'fast-json-stringify';
import { StringSchema } from 'fast-json-stringify';
/**
 *
 * @export
 * @enum {string}
 */
export enum LightlyModelV2 {
    _18 = 'resnet-18',
    _34 = 'resnet-34',
    _50 = 'resnet-50',
    _101 = 'resnet-101',
    _152 = 'resnet-152'
}
/* LIGHTLY CUSTOM START -> modelEnumInterfaces */
export const LightlyModelV2ValidatorShape = [
    'resnet-18',
    'resnet-34',
    'resnet-50',
    'resnet-101',
    'resnet-152'
];
export const LightlyModelV2Validator = yup.mixed().oneOf(LightlyModelV2ValidatorShape);
export const LightlyModelV2StringifyShapeProperties = {};
export const LightlyModelV2StringifyShape: StringSchema = {
    title: 'LightlyModelV2 Stringifier',
    type: 'string'
};
export const LightlyModelV2Stringify = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(LightlyModelV2StringifyShape)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
/* LIGHTLY CUSTOM END */
export function LightlyModelV2FromJSON(json: any): LightlyModelV2 {
    return LightlyModelV2FromJSONTyped(json, false);
}
export function LightlyModelV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): LightlyModelV2 {
    return json as LightlyModelV2;
}
export function LightlyModelV2ToJSON(value?: LightlyModelV2 | null): any {
    return value as any;
}
